import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ValidationMessage } from '@/core/models/validation-message.model';
import { StateService } from '@/core/services/state.service';
import { SectionService } from '@/core/services/section.service';
import { I18nService } from '@/core/services/i18nService';
import { Subscription } from 'rxjs';
import { PortalContextService } from '@/core/services/portal-context.service';
import { AnfrageService } from '@/api/service-index';

@Component({
  selector: 'validation-view',
  templateUrl: './validation-view.component.html',
  styleUrls: ['./validation-view.component.scss']
})
export class ValidationViewComponent implements OnInit, OnDestroy {
  protected _validationMessages: ValidationMessage[] = [];
  protected subscription: Subscription;

  @Input() public languageChangeCallbackFunction = (): void => this.languageChangeAnfrageCallbackFunction()

  public get groupedValidationMessages(): any[] {
    return this.sectionService.FlattenValidationErrors(this.stateService.ValidationErrors);
  }

  public getFormLinkFromGroupedValidationMessage(value: any): string
  {
    return value[0].formLink;
  }

  constructor(public stateService: StateService,
    protected sectionService: SectionService,
    protected languageService: I18nService,
    protected portalContextService: PortalContextService,
    protected anfrageService: AnfrageService) {

    this.subscription = languageService.languageChangedBackend$.subscribe(() => {
      this.languageChangeCallbackFunction();
    })
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.stateService.IsEndvalidationEnabled = true;
  }

  languageChangeAnfrageCallbackFunction() {
    const id: string = this.portalContextService.CurrentAnfrage?.id;
    if (id) {
      this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: id, reportId: this.portalContextService.CurrentBericht?.projektberichtId, gutachtenId: this.portalContextService.CurrentGutachten?.gutachtenId ?? undefined }).subscribe(response => {
        this.stateService.ValidationErrors = response;
      });
    }
  }
}